import _isEmpty from 'lodash/isEmpty';
import _sortBy from 'lodash/sortBy';
import {
  SET_BROWSE_BY,
  SET_BROWSE_BY_FACET,
  SET_SORTS,
  SET_LOAD_MORE,
  SET_POPSTATE,
  SET_FILTERS,
  APPLY_FILTER,
  APPLY_SORT,
  CLEAR_FILTERS,
  SET_FIRST_QUERY,
} from '@/context/recipeFilter/types';

export default (state, action) => {
  switch (action.type) {
    case SET_BROWSE_BY: {
      return {
        ...state,
        browseBy: action.payload,
      };
    }
    case SET_BROWSE_BY_FACET: {
      return {
        ...state,
        browseByFacet: action.payload,
      };
    }
    case SET_FIRST_QUERY: {
      return {
        ...state,
        originalQuery: action.payload,
        query: action.payload,
      };
    }
    case SET_SORTS:
      return { ...state, sorts: action.payload };
    case SET_LOAD_MORE:
      return { ...state, hasLoadMore: action.payload };
    case SET_POPSTATE:
      return { ...state, ...action.payload, updateHistory: false };
    case SET_FILTERS: {
      let filters = action.payload;
      // remove main facet browse by if we are in browse by pages
      const filteredFacets =
        filters.facets &&
        filters.facets.filter(
          facet => facet.code !== state.browseBy && !_isEmpty(facet.values),
        );
      const filteredBreadcrumbs =
        filters.breadcrumbs &&
        filters.breadcrumbs.filter(
          breadcrumb => breadcrumb.facetCode !== state.browseBy,
        );
      filters = {
        ...filters,
        facets: _sortBy(filteredFacets, ['priority']),
        breadcrumbs: filteredBreadcrumbs,
      };
      return {
        ...state,
        filters,
      };
    }
    case APPLY_FILTER:
      return {
        ...state,
        query: {
          ...state.query,
          value: action.payload.query.value,
          url: `${window.location.pathname}${action.payload.url}&hasLoadMore=${state.hasLoadMore}`,
        },
        isFirstLoad: false,
        updateHistory: true,
        appliedFilter: true,
      };
    case APPLY_SORT: {
      const urlParams = new URLSearchParams(window.location.search);
      urlParams.set('sort', action.payload);
      return {
        ...state,
        query: {
          ...state.query,
          sort: action.payload,
          url: `${
            DLG.config.encodedContextPath
          }/search?${urlParams.toString()}`,
        },
        isFirstLoad: false,
        updateHistory: true,
        appliedFilter: true,
      };
    }
    case CLEAR_FILTERS: {
      const clearAllBrowseBy = state.originalQuery;
      const clearAllStandard = {
        value: ':',
        url: `${window.location.pathname}?q=:&hasLoadMore=${state.hasLoadMore}`,
      };
      return {
        ...state,
        query: state.browseBy ? clearAllBrowseBy : clearAllStandard,
        isFirstLoad: false,
        updateHistory: true,
        appliedFilter: true,
      };
    }
    default:
      return { ...state };
  }
};
